<template>
  <div class="entry-content">
    <div class="row">
      <div class="col-md-12">
        <div class="">
          <div class="gap-40"></div>
          <div class="col-md-12 entry-title-admin">
            <div class="row">
              <div class="col-md-8">
              </div>
              <div class="col-md-4 text-right">
                <router-link
                  :to="{ name: 'agent_licenses_create' }"
                  class="btn"
                >
                  <i class="fa fa-plus"></i> Add New License
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div class="gap-40"></div>
    <!-- Agent Licenses Table -->
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-default">
          <div class="panel-heading">
            <h3 class="panel-title">Agent Licenses</h3>
          </div>
          <div class="panel-body">
            <div class="table-responsive">
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>License Number</th>
                    <th>Order Number</th>
                    <th>Path</th>
                    <th>Base</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="license in agentLicenses" :key="license.id">
                    <td>{{ license.name }}</td>
                    <td>{{ license.line_one }}</td>
                    <td>{{ license.order_number }}</td>
                    <td>
                      <a v-if="license.path" :href="license.path" target="_blank" class="text-truncate d-inline-block" style="max-width: 200px;">
                        {{ license.path }}
                      </a>
                      <span v-else class="text-muted">-</span>
                    </td>
                    <td>{{ license.base || '-' }}</td>
                    <td>
                      <div class="btn-group btn-group-sm d-flex" role="group">
                        <router-link
                          :to="{ name: 'agent_licenses_edit', params: { id: license.id } }"
                          class="btn btn-sm"
                          title="Edit"
                        >
                          <i class="fa fa-edit"></i>
                        </router-link>
                        <button
                          class="btn btn-sm btn-danger"
                          @click="deleteLicense(license.id)"
                          title="Delete"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="agentLicenses.length === 0 && !isLoading">
                    <td colspan="7" class="text-center">
                      <div class="alert alert-info">
                        <i class="fa fa-info-circle"></i>
                        No agent licenses found.
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="row" v-if="totalPages > 1">
              <div class="col-md-12">
                <nav aria-label="Agent licenses pagination">
                  <ul class="pagination justify-content-center">
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                        Previous
                      </a>
                    </li>
                    <li 
                      v-for="page in visiblePages" 
                      :key="page"
                      class="page-item"
                      :class="{ active: page === currentPage }"
                    >
                      <a class="page-link" href="#" @click.prevent="changePage(page)">
                        {{ page }}
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                        Next
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading Spinner -->
    <div v-if="isLoading" class="text-center">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
      <p>Loading agent licenses...</p>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash-es';
import { configs } from "@/lib/axios";
export default {
  name: 'AgentLicenseIndex',
  data() {
    return {
      agentLicenses: [],
      isLoading: false,
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      filters: {
        name: '',
        license_number: '',
        status: ''
      },
      debounceSearch: null
    };
  },
  computed: {
    visiblePages() {
      const pages = [];
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(this.totalPages, this.currentPage + 2);
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      
      return pages;
    }
  },
  mounted() {
    this.setupDebounce();
    this.loadAgentLicenses();
    this.setupBreadcrumbs();
  },
  methods: {
    setupDebounce() {
      this.debounceSearch = debounce(() => {
        this.currentPage = 1;
        this.loadAgentLicenses();
      }, 300);
    },
    
    setupBreadcrumbs() {
      this.$store.commit("app/SET_BREADCRUMBS", [
        {
          name: "Dashboard",
          url: "home"
        },
        {
          name: "Admin",
          url: "admin_users"
        },
        {
          name: "Agent Licenses",
          url: null,
          active: true
        }
      ]);
    },
    
    async loadAgentLicenses() {
      this.isLoading = true;
      try {
        const params = {
          page: this.currentPage,
          ...this.filters
        };
        
        const response = await configs.get(
          `/admin/agent-licenses`,
          { params }
        );
        
        this.agentLicenses = response?.data?.data || response?.data||[];
        this.totalItems = response?.data?.total || this.agentLicenses.length;
        this.totalPages = response?.data?.last_page || 1;
      } catch (error) {
        console.error('Error loading agent licenses:', error);
        this.$toast.error('Error loading agent licenses');
      } finally {
        this.isLoading = false;
      }
    },
    
    async deleteLicense(licenseId) {
      if (!confirm('Are you sure you want to delete this agent license?')) {
        return;
      }
      
      try {
        await configs.delete(`/admin/agent-licenses/${licenseId}`);
        
        // this.$toast.success('Agent license deleted successfully');
        this.loadAgentLicenses();
      } catch (error) {
        console.error('Error deleting agent license:', error);
        this.$toast.error('Error deleting agent license');
      }
    },
    
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.loadAgentLicenses();
      }
    },
    
    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('en-AU');
    }
  }
};
</script>

<style scoped>
.entry-header-admin {
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 20px;
}

.entry-title-admin {
  margin-bottom: 0;
}

.panel {
  border: 1px solid #ddd;
  border-radius: 5px;
}

.panel-heading {
  background-color: #f8f9fa;
  border-bottom: 1px solid #ddd;
  padding: 10px 15px;
}

.panel-title {
  margin: 0;
  font-size: 16px;
  font-weight: bold;
}

.panel-body {
  padding: 15px;
}

.btn-group .btn {
  margin-right: 2px;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.badge-success {
  background-color: #28a745;
}

.badge-secondary {
  background-color: #6c757d;
}
</style> 